import api from "./base-api"
import {v4 as uuidv4} from "uuid";

const mcAnalyticalDataApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getConsumablesV1MC: build.query({
            query: (
                data
            ) => {
                return `v1/mc/analytical-data/${data.userId}/consumables?limit=${data.limit}&page=0&from=${data.from}&to=${data.to}`
            },
            transformResponse: (response) => {
                const rows = response.map((row) => ({id: uuidv4(), ...row}));
                return {rows};
            },
        }),
        getEnvironmentsV1MC: build.query({
            query: (
                userId = "",
                limit = 1,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/environments?limit=${limit}&page=${page}`
        }),
        getLevelsV1MC: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/levels?limit=${limit}&page=${page}`
        }),
        getPaymentsV1MC: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/payments?limit=${limit}&page=${page}`
        }),
        getSpendItemsMC: build.query({
            query: (
                data
            ) => `v1/mc/analytical-data/${data.userId}/spendItems?limit=${data.limit}&page=${data.page}`
        }),
        getPurchaseMC: build.query({
            query: (data) => {
                const params = new URLSearchParams({
                    payload: data.payload,
                    from: data.from,
                    to: data.to,
                    limit: data.limit ?? 100,
                })
                if (data.lastId != null) params.set("lastId", data.lastId)
                if (data.lastTimestamp != null) params.set("lastTimestamp", data.lastTimestamp)
                return `v1/mc/analytical-data/${data.userId}/purchases?${params}`
            }
        }),
        getPurchaseItemsMC: build.query({
            query: (
                data
            ) => `v1/mc/analytical-data/${data.userId}/purchaseItems?limit=${data.limit}&page=${data.page}`
        }),
        getSpendGroupItemsMC: build.query({
            query: (
                data
            ) => `v1/mc/analytical-data/${data.userId}/spendGroup`
        }),
        getBattlesV1MC: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/battles?limit=${limit}&page=${page}`
        }),
        getPurchasesV1MC: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/purchases?limit=${limit}&page=${page}`
        }),
        getUserInfoV1MC: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/mc/analytical-data/${userId}/user-info?limit=${limit}&page=${page}`
        }),
    }),
    overrideExisting: false
})

export const {
    useGetConsumablesV1MCQuery,
    useGetEnvironmentsV1MCQuery,
    useGetUserInfoV1MCQuery,
    useGetLevelsV1MCQuery,
    useGetPaymentsV1MCQuery,
    useGetSpendGroupItemsMCQuery,
    useGetPurchaseMCQuery,
    useGetPurchaseItemsMCQuery,
    useGetSpendItemsMCQuery,
    useGetBattlesV1MCQuery,
    useGetPurchasesV1MCQuery
} = mcAnalyticalDataApiV1
